/* eslint-disable */
export const environment: {
    kushkiUrl: string;
    envName: string;
    devTools: boolean;
    firebaseConfig: {
        apiKey: string;
        authDomain: string;
        databaseURL: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
    };
  merchantsBlockedNavigation: {
      merchantId: string;
      routes: string[];
      modules: string[];
    }[];
   complianceHistoric: boolean;
   showSettlementSection: boolean;
   showSettlementDistribution: boolean;
   allowedCountriesSettlementDistribution: string;
} = {
    kushkiUrl: "https://api-uat.kushkipagos.com",
    envName: "uat",
    devTools: false,
    firebaseConfig: {
        apiKey:'AIzaSyAYyH7IuISpUAoCN1zN9VWr7I7FjEKwY9I',
        authDomain:'kushki-97eba.firebaseapp.com',
        databaseURL: 'https://kushki-97eba.firebaseio.com',
        projectId: 'kushki-97eba',
        storageBucket: 'kushki-97eba.appspot.com',
        messagingSenderId: '821114948879'
    },
    merchantsBlockedNavigation: [],
    complianceHistoric: true,
    showSettlementSection: true,
    showSettlementDistribution: true,
    allowedCountriesSettlementDistribution: "Mexico,Peru,Colombia,Chile"
};

